/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Choose_T1Inputs */

const en_site_choose_t1 = /** @type {(inputs: Site_Choose_T1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a URL`)
};

const id_site_choose_t1 = /** @type {(inputs: Site_Choose_T1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempel URL`)
};

/**
* | output |
* | --- |
* | "Paste a URL" |
*
* @param {Site_Choose_T1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_choose_t1 = /** @type {((inputs?: Site_Choose_T1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Choose_T1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_choose_t1(inputs)
	return en_site_choose_t1(inputs)
});